import React from 'react';
import { Link } from 'react-router-dom';
import { creditPurchaseDetailPath } from '../../services/CreditService';

const CREDIT_MIN_DECIMALS = 2;
const CREDIT_MAX_DECIMALS = 6;

export function formatCreditMoney(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return '0.00';
  const [intPart, fracPart = ''] = n.toFixed(CREDIT_MAX_DECIMALS).split('.');
  let frac = fracPart.replace(/0+$/, '');
  if (frac.length < CREDIT_MIN_DECIMALS) {
    frac = frac.padEnd(CREDIT_MIN_DECIMALS, '0');
  }
  return `${intPart}.${frac}`;
}

export function formatCreditDate(value) {
  if (!value) return '—';
  return new Date(value).toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  });
}

export function formatCreditDateTime(value) {
  if (!value) return '—';
  return new Date(value).toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  });
}

export function formatCreditSource(source) {
  if (!source) return '—';
  return String(source).replace(/_/g, ' ');
}

export function formatCreditStatus(status) {
  if (!status) return '—';
  return String(status).replace(/_/g, ' ');
}

export function creditDetailsColumn() {
  return {
    key: 'details',
    header: '',
    headerClassName: 'credit-wallet-details-col',
    cellClassName: 'credit-wallet-details-col',
    render: (row) => (
      <Link
        to={creditPurchaseDetailPath(row.ref_id)}
        className="credit-wallet-row-open"
        title="View details"
        aria-label={`View details for #${row.ref_id}`}
        onClick={(e) => e.stopPropagation()}
      >
        <i className="fas fa-chevron-right" aria-hidden="true" />
      </Link>
    ),
  };
}
